import {
    PERITADOR_ACT_ORIGIN_CHANNEL_BEGIN,
    PERITADOR_ACT_ORIGIN_CHANNEL_SUCCESS,
    PERITADOR_ACT_ORIGIN_CHANNEL_FAILURE,
    PERITADOR_ACT_ORIGIN_CHANNEL_DISMISS_ERROR,
  } from './constants'
  import { Peritador } from '../../../common/BFF/BFF_peritador'
  
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function actOriginChannel(args = {}) {
    return (dispatch) => {
      // optionally you can have getState as the second argument
      dispatch({
        type: PERITADOR_ACT_ORIGIN_CHANNEL_BEGIN,
      })
      return new Promise(async (resolve, reject) => {
      Peritador.getOriginChannels().then(
        (res) => {
        dispatch({
          type: PERITADOR_ACT_ORIGIN_CHANNEL_SUCCESS,
          data: res
        })
        resolve()
        },
        (err) => {
          dispatch({
            type: PERITADOR_ACT_ORIGIN_CHANNEL_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })
    
    }
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissActOriginChannelError() {
    return {
      type: PERITADOR_ACT_ORIGIN_CHANNEL_DISMISS_ERROR,
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PERITADOR_ACT_ORIGIN_CHANNEL_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          actOriginChannelPending: true,
          actOriginChannelError: null,
        }
  
      case PERITADOR_ACT_ORIGIN_CHANNEL_SUCCESS:
        // The request is success
        return {
          ...state,
          actOriginChannelPending: false,
          actOriginChannelError: null,
          originChannels: action.data,
        }
  
      case PERITADOR_ACT_ORIGIN_CHANNEL_FAILURE:
        // The request is failed
        return {
          ...state,
          actOriginChannelPending: false,
          actOriginChannelError: action.data.error,
        }
  
      case PERITADOR_ACT_ORIGIN_CHANNEL_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          actOriginChannelError: null,
        }
  
      default:
        return state
    }
  }